import { Container, Group, Text, createStyles } from '@mantine/core'
import Link from 'next/link'

import type { MenuLink, SubLink } from '@testsa-com/common/src/types/Menu.type'
import { useUserStore } from '../stores/useUserStore'
import styles from '../styles/layout/Footer.module.scss'

const useStyles = createStyles(theme => ({
  inner: {
    [theme.fn.smallerThan('xs')]: {
      flexDirection: 'column',
    },
  },

  links: {
    [theme.fn.smallerThan('xs')]: {
      marginTop: theme.spacing.md,
    },
  },
}))

interface FooterProps {
  links: MenuLink[]
}

export function Footer({ links }: FooterProps) {
  const { classes, cx } = useStyles()
  const items = links.map(l =>
    l.subLinks ? (
      (l.subLinks.filter(sl => sl.type === 'link') as SubLink[]).map(sl => (
        <Link key={sl.label} href={sl.link ?? ''}>
          <Text color="dimmed" size="sm">
            {sl.label}
          </Text>
        </Link>
      ))
    ) : (
      <Link key={l.label} href={l.link ?? ''}>
        <Text color="dimmed" size="sm">
          {l.label}
        </Text>
      </Link>
    ),
  )
  const userStore = useUserStore()

  return (
    <footer className={styles.footer}>
      <Container className={cx(styles.inner, classes.inner)}>
        {userStore.me?.type === 'user' && <Group className={classes.links}>{items}</Group>}
      </Container>
    </footer>
  )
}
